import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";

export const getContractorInfo = (axios: IAxiosInstance) => {
  return async (contractorID: string) => {
    const response = await axios.noRetry.get<
      ISchema["#/definitions/IGetContractorInfoResponse"]
    >(`/api/getContractorInfo`, {
      params: { contractorID },
    });
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
